'use client';

import { c as _c } from "react/compiler-runtime";
import { Radio } from '@common/components';
import { cn } from '@core/utils';
import type { DetailHomeGiftProductResponse } from '@generated/unauth';
import { useRef } from 'react';
import CountUp from 'react-countup';
import { formatOptionLabel } from '../../../../_utils/formatOptionLabel';
import { useGiftOption } from '../../_context/GiftOptionContext';
import { AddToCartButton } from '../AddToCartButton';
interface PrefillFormProps {
  productData?: DetailHomeGiftProductResponse;
  productNumber: string;
  className?: string;
}
export const PrefillForm = t0 => {
  const $ = _c(52);
  const {
    productData,
    productNumber,
    className
  } = t0;
  const {
    selectedOptions,
    handleOptionSelect,
    getCartOptions
  } = useGiftOption();
  let hasOptions;
  let isAllRequiredOptionsSelected;
  let isSingleOptionGroup;
  let optionGroups;
  let selectedOptionText;
  let t1;
  let totalPrice;
  if ($[0] !== productData?.optionGroupInfoList || $[1] !== productData?.requiredDonationAmount || $[2] !== selectedOptions) {
    optionGroups = productData?.optionGroupInfoList ?? [];
    hasOptions = optionGroups.length > 0;
    const basePrice = productData?.requiredDonationAmount ?? 0;
    const requiredOptionGroups = optionGroups.filter(_temp);
    isAllRequiredOptionsSelected = hasOptions && requiredOptionGroups.every(g_0 => selectedOptions.has(g_0.optionGroupId ?? 0));
    let t2;
    bb0: {
      if (!isAllRequiredOptionsSelected) {
        t2 = null;
        break bb0;
      }
      const optionNames = [];
      optionGroups.forEach(group => {
        const selected = selectedOptions.get(group.optionGroupId ?? 0);
        if (selected) {
          const optionItem = group.optionItemInfoList?.find(item => item.optionItemId === selected.optionItemId);
          if (optionItem?.itemName) {
            optionNames.push(optionItem.itemName);
          }
        }
      });
      t2 = optionNames.join(" ");
    }
    selectedOptionText = t2;
    let t3;
    bb1: {
      if (!hasOptions) {
        t3 = basePrice;
        break bb1;
      }
      if (selectedOptions.size === 0) {
        t3 = basePrice;
        break bb1;
      }
      let totalExtraPrice;
      if ($[10] !== selectedOptions) {
        totalExtraPrice = 0;
        selectedOptions.forEach(opt => {
          totalExtraPrice = totalExtraPrice + opt.extraPrice;
          totalExtraPrice;
        });
        $[10] = selectedOptions;
        $[11] = totalExtraPrice;
      } else {
        totalExtraPrice = $[11];
      }
      t3 = basePrice + totalExtraPrice;
    }
    totalPrice = t3;
    isSingleOptionGroup = optionGroups.length === 1;
    t1 = optionGroups.filter(_temp2).map(_temp3);
    $[0] = productData?.optionGroupInfoList;
    $[1] = productData?.requiredDonationAmount;
    $[2] = selectedOptions;
    $[3] = hasOptions;
    $[4] = isAllRequiredOptionsSelected;
    $[5] = isSingleOptionGroup;
    $[6] = optionGroups;
    $[7] = selectedOptionText;
    $[8] = t1;
    $[9] = totalPrice;
  } else {
    hasOptions = $[3];
    isAllRequiredOptionsSelected = $[4];
    isSingleOptionGroup = $[5];
    optionGroups = $[6];
    selectedOptionText = $[7];
    t1 = $[8];
    totalPrice = $[9];
  }
  const requiredOptionGroupIds = t1;
  const optionSectionRef = useRef(null);
  let t2;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      optionSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    };
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const scrollToOptionSection = t2;
  if (!productData) {
    return null;
  }
  let t3;
  if ($[13] !== className) {
    t3 = cn("flex flex-col gap-36", className);
    $[13] = className;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== handleOptionSelect || $[16] !== isSingleOptionGroup || $[17] !== optionGroups || $[18] !== selectedOptions) {
    let t5;
    if ($[20] !== handleOptionSelect || $[21] !== isSingleOptionGroup || $[22] !== selectedOptions) {
      t5 = optionGroup => {
        const groupId = optionGroup.optionGroupId ?? 0;
        const selectedInGroup = selectedOptions.get(groupId);
        return <div key={groupId} className="flex flex-col">{optionGroup.optionGroupName && <p className="flex items-center gap-4 pb-8 pt-16 font-500 text-Gray-600 typo-body4">{isSingleOptionGroup ? "\uC0C1\uD488\uC635\uC158 \uC120\uD0DD" : optionGroup.optionGroupName}{optionGroup.requiredYN && <span className="font-600 text-R-500">*</span>}</p>}<Radio.Group value={selectedInGroup?.optionItemId} onChange={selectedItemId => {
            const selectedItem = optionGroup.optionItemInfoList?.find(item_0 => item_0.optionItemId === selectedItemId);
            if (selectedItem && !selectedItem.displaySoldOutYN) {
              handleOptionSelect(groupId, selectedItemId as number, selectedItem.extraPrice ?? 0);
            }
          }} theme="black" className="flex flex-col">{optionGroup.optionItemInfoList?.map(optionItem_0 => {
              const itemId = optionItem_0.optionItemId ?? 0;
              const isSoldOut = optionItem_0.displaySoldOutYN ?? false;
              const displayLabel = formatOptionLabel(optionItem_0.itemName ?? "", {
                isSoldOut,
                extraPrice: optionItem_0.extraPrice
              });
              return <div key={itemId} className="flex items-center gap-16 border-b border-Gray-200 py-16"><button type="button" onClick={() => {
                  if (!isSoldOut) {
                    handleOptionSelect(groupId, itemId, optionItem_0.extraPrice ?? 0);
                  }
                }} disabled={isSoldOut} className={cn("flex flex-1 items-center", isSoldOut && "cursor-not-allowed opacity-50")}><Radio.Item value={itemId} className="pointer-events-none"><span className="flex-1 text-left font-400 text-Gray-700 typo-body4">{displayLabel}</span></Radio.Item></button></div>;
            })}</Radio.Group></div>;
      };
      $[20] = handleOptionSelect;
      $[21] = isSingleOptionGroup;
      $[22] = selectedOptions;
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    t4 = optionGroups.map(t5);
    $[15] = handleOptionSelect;
    $[16] = isSingleOptionGroup;
    $[17] = optionGroups;
    $[18] = selectedOptions;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[24] !== isAllRequiredOptionsSelected || $[25] !== selectedOptionText) {
    t5 = isAllRequiredOptionsSelected && selectedOptionText && <div className="flex flex-col items-center justify-center rounded-small bg-Gray-25 p-12"><div className="flex w-full items-center justify-between"><span className="font-400 text-Gray-800 typo-caption1">{selectedOptionText}</span></div></div>;
    $[24] = isAllRequiredOptionsSelected;
    $[25] = selectedOptionText;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t4 || $[28] !== t5) {
    t6 = <div ref={optionSectionRef} data-gift-option-section={true} className="flex flex-col gap-28">{t4}{t5}</div>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-600 text-Gray-900 typo-h6">기부금액</span>;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== totalPrice) {
    t8 = <CountUp preserveValue={true} end={totalPrice} duration={0.3} delay={0.2} />;
    $[31] = totalPrice;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>원</span>;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== t8) {
    t10 = <div className="flex items-center justify-between">{t7}<span className="flex items-center gap-2 font-800 text-Gray-900 typo-h4">{t8}{t9}</span></div>;
    $[34] = t8;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== getCartOptions || $[37] !== optionGroups) {
    t11 = getCartOptions(optionGroups);
    $[36] = getCartOptions;
    $[37] = optionGroups;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== hasOptions || $[40] !== productData || $[41] !== productNumber || $[42] !== requiredOptionGroupIds || $[43] !== t11) {
    t12 = <AddToCartButton productInfo={productData} productNumber={productNumber} selectedOptions={t11} hasOptions={hasOptions} requiredOptionGroupIds={requiredOptionGroupIds} theme="primary-fill" onOptionNotSelected={scrollToOptionSection} />;
    $[39] = hasOptions;
    $[40] = productData;
    $[41] = productNumber;
    $[42] = requiredOptionGroupIds;
    $[43] = t11;
    $[44] = t12;
  } else {
    t12 = $[44];
  }
  let t13;
  if ($[45] !== t10 || $[46] !== t12) {
    t13 = <div className="flex flex-col gap-24 mobile:hidden tablet:hidden">{t10}{t12}</div>;
    $[45] = t10;
    $[46] = t12;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== t13 || $[49] !== t3 || $[50] !== t6) {
    t14 = <form onSubmit={_temp4} className={t3}>{t6}{t13}</form>;
    $[48] = t13;
    $[49] = t3;
    $[50] = t6;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  return t14;
};
function _temp(g) {
  return g.requiredYN;
}
function _temp2(g_1) {
  return g_1.requiredYN;
}
function _temp3(g_2) {
  return g_2.optionGroupId;
}
function _temp4(e) {
  e.preventDefault();
}